import { Store, useAppDispatch } from 'src/redux/Store';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { openModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import ContactCreditCardDisplayer from 'src/components/Elements/ContactCreditCardDisplayer';
import ButtonLink from 'src/components/Elements/ButtonLink';
import SubmenuLink from 'src/components/Elements/SubmenuLink';
import { useEffect, useState } from 'react';
import { getContactIdForUserAction } from 'src/redux/actions/contactActions';
import ContactBankAccountDisplayer from 'src/components/Elements/ContactBankAccountDisplayer';

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'bottom',
    height: '4vh',
    gap: '10px',
  },
  header: {
    paddingLeft: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    maxWidth: '640px',
  },
  subheader: {
    fontSize: '0.75rem',
    fontWeight: 'bold',
    marginTop: '12px',
    marginBottom: '4px',
  },
}));

const UserPaymentSettingsPage = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const userId = useSelector((state: Store) => state.user.id);
  const [contactId, setContactId] = useState(0);

  const getContactId = async () => {
    const result = await dispatch(getContactIdForUserAction(userId));
    setContactId(result);
  };

  useEffect(() => {
    getContactId();
  }, []);

  const openAddBankAccountModal = () => {
    dispatch(openModal({
      modal: MODALS.addBankAccount,
      payload: {
        contact_id: contactId,
      },
    }));
  };

  const openAddCreditCardModal = () => {
    dispatch(openModal({
      modal: MODALS.addCreditCard,
      payload: {
        contact_id: contactId,
      },
    }));
  };

  return (
    <div>
      <div className={`${classes.row} ${classes.header}`}>
        <SubmenuLink
          noMargin
        >
          <span>Payment Information</span>
        </SubmenuLink>
      </div>
      <div className={classes.subheader}>Credit Cards</div>
      <ContactCreditCardDisplayer contactId={contactId} />
      <ButtonLink onClick={() => openAddCreditCardModal()}>Add a credit card</ButtonLink>
      <br />
      <div className={classes.subheader}>Bank Accounts</div>
      <ContactBankAccountDisplayer contactId={contactId} />
      <ButtonLink onClick={() => openAddBankAccountModal()}>Add a bank account</ButtonLink>
    </div>
  );
};

export default UserPaymentSettingsPage;
